import { PercentageDepositRoundingModeEnum } from '../../tenant/settings/enums/percentage-deposit-rounding-mode.enum';
import { PercentageDepositRoundingConfig } from '../../tenant/settings/interfaces/percentage-deposit-rounding-config.interface';

/**
 * Rounds an amount to the configured increment when percentage-deposit rounding
 * is enabled. Returns the amount unchanged when disabled.
 */
export function applyPercentageDepositRounding(
  amount: number,
  config: PercentageDepositRoundingConfig | null | undefined,
): number {
  if (!config?.isEnabled) {
    return amount;
  }

  const increment = Number(config.increment ?? 0);
  if (!(increment > 0)) {
    return amount;
  }

  const mode = config.mode ?? PercentageDepositRoundingModeEnum.NEAREST;
  const ratio = amount / increment;

  switch (mode) {
    case PercentageDepositRoundingModeEnum.UP:
      return Math.ceil(ratio) * increment;
    case PercentageDepositRoundingModeEnum.DOWN:
      return Math.floor(ratio) * increment;
    case PercentageDepositRoundingModeEnum.NEAREST:
    default:
      return Math.round(ratio) * increment;
  }
}
